// import React, { useState } from "react";
// import tw, { styled } from "twin.macro";
// import VectorDesign from "images/Vector1.svg";
// import VectorDesign1 from "images/hGreenDot.png";
// import VectorDesign2 from "images/dottedCircle.svg";
// import VectorDesign3 from "images/blueDots.svg";
// import GrayDesign from "images/blueDots.svg";
// import LineDesign from "images/greenLines.png";
// import WhiteArrow from "images/Vector1.svg";

// // Fixed colors using arbitrary values
// const accentColor = "#0d9488"; // Deep teal
// const accentLight = "#14b8a6"; // Lighter teal
// const IconImage = styled.img`
//   ${tw`w-30 sm:w-32 mt-3 mb-0`}
// `;

// const DecorativeImage = styled.img`
//   ${tw`absolute z-0`}
//   width: auto;
//   height: auto;
//   transition: transform 1s ease-in-out;

//   &:hover {
//     transform: scale(1.1) rotate(8deg);
//   }

//   &.top-left {
//     top: 5%;
//     left: 3%;
//   }

//   &.right-mid {
//     top: 80%;
//     right: 4%;
//   }

//   &.right-bottom {
//     top: 100%;
//     right: 2%;

//     z-index: -1;
//   }

//   @media (max-width: 768px) {
//     width: 80px;
//     opacity: 0.25;
//   }
// `;

// // Gradient text for hero heading
// const HeroTitle = styled.h1`
//   ${tw`text-5xl sm:text-6xl md:text-6xl lg:text-6xl font-black tracking-tight mb-4 text-[#3f6c68]`}
// `;

// // Section heading style
// const SectionHeading = tw.h2`
//   text-4xl md:text-5xl font-bold text-center mb-12 relative inline-block text-[#3f6c68]
// `;

// const SectionHeadingUnderline = styled.span`
//   ${tw`absolute left-0 right-0 bottom-[-12px] h-1 bg-gradient-to-r`}
//   background-image: linear-gradient(to right, transparent, #14b8a6, transparent);
// `;

// // Left-aligned heading for boxes
// const BoxHeading = tw.h3`
//   text-3xl md:text-3xl font-bold mb-8 text-[#1e293b] relative pb-4
// `;

// const BoxHeadingUnderline = styled.span`
//   ${tw`absolute left-0 bottom-0 w-24 h-1`}
//   background-color: #14b8a6;
// `;

// // ---------- Main Styled Components ----------
// const PageWrapper = tw.div`bg-[#f8fafc] min-h-screen`;

// const HeroSection = styled.section`
//   ${tw`relative  text-white text-justify flex items-center pb-40`}
// `;

// const HeroInner = tw.div`max-w-6xl mx-auto px-6 text-center`;

// const HeroParagraph = tw.p`
//   text-lg md:text-xl lg:text-2xl text-black text-justify max-w-6xl mx-auto leading-relaxed
// `;

// const Section = tw.section`max-w-6xl mx-auto px-6 pt-0`;

// const TwoCol = tw.div`grid md:grid-cols-2 gap-4 lg:gap-4 items-center`;

// const PhilosophyBox = tw.div`
//   bg-white p-10 lg:p-10 rounded-3xl shadow-2xl hover:shadow-2xl transition-shadow duration-500
// `;

// const ImageStyled = tw.img`
//   w-full max-w-md mx-auto rounded-3xl  object-cover
// `;

// const MentorWrapper = tw.section`
//   bg-gradient-to-b from-[#f8fafc] to-white pt-40
// `;

// const MentorHeading = tw.h1`
//   text-center text-2xl lg:text-4xl font-bold mb-10 underline
// `;

// const MentorCard = tw.div`

// `;

// const HighlightItem = styled.div`
//   ${tw`my-4`}
//   perspective: 1000px;
// `;

// const FlipBox = styled.div`
//   ${tw`relative w-full h-40 lg:h-24 transition-transform duration-500 border-2 border-[#3f6c68] rounded-2xl shadow-lg cursor-pointer`}
//   transform-style: preserve-3d;

//   ${HighlightItem}:hover & {
//     transform: rotateX(180deg);
//   }
// `;

// const FlipFace = styled.div`
//   ${tw`absolute inset-0 flex items-center p-5 rounded-2xl border-l-4 border-[#3f6c68] bg-[#3f6c68] shadow-md`}
//   backface-visibility: hidden;
// `;

// const FlipFront = styled(FlipFace)`
//   ${tw`font-bold text-lg text-[#fff]`}
// `;

// const FlipBack = styled(FlipFace)`
//   ${tw`text-black leading-relaxed bg-transparent border-2 border-[#3f6c68] text-sm font-semibold`}
//   transform: rotateX(180deg);
// `;

// // ---------- Component ----------
// const AboutUs = ({
//   imageSrc1 = VectorDesign,
//   imageSrc2 = GrayDesign,
//   imageSrc3 = LineDesign,
// }) => {
//   const IconImage = styled.img`
//     ${tw`w-30 sm:w-32 mt-0 mb-2`}
//   `;

//   const IllustrationContainer = styled.div`
//     ${tw`relative flex justify-center items-center`}

//     &:hover img.floating {
//       animation-play-state: running;
//     }

//     img.floating {
//       animation-play-state: paused;
//     }
//   `;

//   const MainImage = tw.img`
//   w-full max-w-md mx-auto rounded-3xl object-cover
// `;

//   const FloatingLayer = styled.img`
//     ${tw`absolute pointer-events-none`}
//     animation: float 3s ease-in-out infinite;

//     @keyframes float {
//       0% {
//         transform: translate(0, 0);
//       }
//       50% {
//         transform: translate(10px, -10px);
//       }
//       100% {
//         transform: translate(0, 0);
//       }
//     }
//   `;

//   const MentorImageWrap = styled.div`
//     ${tw`relative flex justify-center items-center`}

//     &:hover .float {
//       animation-play-state: running;
//     }

//     .float {
//       animation-play-state: paused;
//     }
//   `;

//   const DecorativeImage = styled.img`
//     ${tw`absolute pointer-events-none`}
//     animation: float 3s ease-in-out infinite;

//     @keyframes float {
//       0% {
//         transform: translate(0, 0);
//       }
//       50% {
//         transform: translate(10px, -10px);
//       }
//       100% {
//         transform: translate(0, 0);
//       }
//     }
//   `;

//   const handleParallaxMove = (e) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const x = e.clientX - rect.left - rect.width / 2;
//     const y = e.clientY - rect.top - rect.height / 2;
//     setOffset({ x: x / 25, y: y / 25 });
//   };
//   const [offset, setOffset] = useState({ x: 0, y: 0 });
//   return (
//     <PageWrapper>
//       {/* HERO SECTION */}
//       <HeroSection>
//         <HeroInner>
//           <HeroTitle>
//             About Us
//             <div style={{ marginTop: "-25px" }}>
//               <IconImage
//                 style={{ color: "#fff" }}
//                 src={WhiteArrow}
//                 alt="vector icon"
//               />
//             </div>
//           </HeroTitle>
//           <HeroParagraph>
//             CA Vijender Aggarwal Classes is a dedicated platform for CA and CMA
//             aspirants who seek strong conceptual clarity, practical
//             understanding, and result-oriented preparation in Direct and
//             Indirect Taxes. Our focus goes beyond merely completing the syllabus
//             — we help students understand the taxation domain logically and
//             apply it confidently in examinations as well as real-life scenarios.
//             Along with academic excellence, we also provide proper practical
//             exposure to ensure holistic learning.
//           </HeroParagraph>
//         </HeroInner>
//       </HeroSection>

//       {/* TEACHING PHILOSOPHY */}
//       <Section>
//         <TwoCol>
//           <IllustrationContainer>
//             <MainImage src="https://qsfiles.b-cdn.net/vg1.png" />

//             {/* BEFORE image */}
//             <FloatingLayer
//               className="floating"
//               src={imageSrc2}
//               style={{ top: "-30px", left: "-30px" }}
//             />

//             {/* AFTER image */}
//             <FloatingLayer
//               className="floating"
//               src={imageSrc2}
//               style={{ bottom: "-20px", right: "-20px" }}
//             />
//           </IllustrationContainer>

//           <PhilosophyBox>
//             <DecorativeImage
//               src={VectorDesign2}
//               alt="decoration"
//               style={{ bottom: "-20px", right: "-20px" }}
//             />

//             <BoxHeading>
//               TEACHING PHILOSOPHY
//               <BoxHeadingUnderline />
//             </BoxHeading>

//             <p
//               tw="mb-8 text-gray-700 text-lg leading-relaxed"
//               style={{ textAlign: "justify", lineHeight: "1.60" }}
//             >
//               At CA Vijender Aggarwal Classes, teaching goes beyond books. Every
//               topic is explained in a simplified, exam-oriented, and practical
//               manner, keeping in mind the challenges faced by CA/CMA students
//               today.
//             </p>

//             <ul
//               tw="space-y-4 text-gray-700 text-lg list-none pl-0"
//               style={{
//                 listStyle: "none",
//                 paddingLeft: "10px",
//                 lineHeight: "1.60",
//               }}
//             >
//               <li tw="flex items-start gap-3" style={{ paddingBottom: "16px" }}>
//                 <span tw="text-[#14b8a6] mt-1 text-2xl font-bold">✓ </span>
//                 <span>
//                   Focus on conceptual clarity & practical application of the
//                   subject to simplify the process of interpretation & learning
//                   of law.
//                 </span>
//               </li>
//               <li tw="flex items-start gap-3" style={{ paddingBottom: "16px" }}>
//                 <span tw="text-[#14b8a6] mt-1 text-2xl font-bold">✓ </span>
//                 <span>
//                   Use of real-world and practical examples for better
//                   understanding.
//                 </span>
//               </li>
//               <li tw="flex items-start gap-3" style={{ paddingBottom: "16px" }}>
//                 <span tw="text-[#14b8a6] mt-1 text-2xl font-bold">✓ </span>
//                 <span>
//                   Exam-focused preparation aligned with current CA/CMA patterns.
//                 </span>
//               </li>
//               <li tw="flex items-start gap-3" style={{ paddingBottom: "16px" }}>
//                 <span tw="text-[#14b8a6] mt-1 text-2xl font-bold">✓ </span>
//                 <span>
//                   Regular revision and structured practice to reinforce
//                   learning.
//                 </span>
//               </li>
//               <li tw="flex items-start gap-3" style={{ paddingBottom: "16px" }}>
//                 <span tw="text-[#14b8a6] mt-1 text-2xl font-bold">✓ </span>
//                 <span>
//                   Practical exposure to bridge the gap between theory and
//                   real-life application.
//                 </span>
//               </li>
//             </ul>
//             <p
//               tw="mb-8 text-gray-700 text-lg leading-relaxed"
//               style={{ textAlign: "justify", lineHeight: "1.60" }}
//             >
//               At CA Vijender Aggarwal Classes, we aim to create confident
//               professionals who are well-prepared not only for examinations but
//               also for real-world professional responsibilities.
//             </p>
//           </PhilosophyBox>
//         </TwoCol>
//       </Section>

//       {/* ABOUT MENTOR */}
//       <MentorWrapper>
//         <MentorHeading>
//           About CA Vijender Aggarwal <br />
//           <IconImage
//             style={{ color: "#fff" }}
//             src={imageSrc1}
//             alt="vector icon"
//           />
//         </MentorHeading>

//         <Section>
//           <TwoCol>
//             <MentorCard tw="order-1 md:order-2">
//               <div tw="space-y-6">
//                 <HighlightItem>
//                   <FlipBox>
//                     <FlipFront>Top-Notch Graduation</FlipFront>

//                     <FlipBack style={{ border: "solid 2px #3f6c68" }}>
//                       Alumnus Of Shri Ram College Of Commerce (SRCC), Delhi
//                       University, Widely Considered As India's Most Prestigious
//                       College For Commerce & Economics
//                     </FlipBack>
//                   </FlipBox>
//                 </HighlightItem>
//                 <HighlightItem>
//                   <FlipBox>
//                     <FlipFront>Academic Excellence Beyond Comparison</FlipFront>

//                     <FlipBack style={{ border: "solid 2px #3f6c68" }}>
//                       Secured 91% Marks At CA–Foundation Level & Achieved The
//                       Rare Distinction Of ‘ALL INDIA RANK 1' At Both
//                       CA–Intermediate & CA–Final Examinations .
//                     </FlipBack>
//                   </FlipBox>
//                 </HighlightItem>
//                 <HighlightItem>
//                   <FlipBox>
//                     <FlipFront>Best Paper Award Achievements</FlipFront>

//                     <FlipBack style={{ border: "solid 2px #3f6c68" }}>
//                       Recipient Of Multiple Best Paper Awards, Including
//                       Taxation (CA–Intermediate) and Advanced Management
//                       Accounting & Indirect Taxes (CA–Final).
//                     </FlipBack>
//                   </FlipBox>
//                 </HighlightItem>
//                 <HighlightItem>
//                   <FlipBox>
//                     <FlipFront>Big-4 Articleship</FlipFront>

//                     <FlipBack style={{ border: "solid 2px #3f6c68" }}>
//                       Completed Articleship Training With Deloitte, A Globally
//                       Renowned Big-4 Professional Services Firm.
//                     </FlipBack>
//                   </FlipBox>
//                 </HighlightItem>
//                 <HighlightItem>
//                   <FlipBox>
//                     <FlipFront>Seasoned Professional</FlipFront>

//                     <FlipBack style={{ border: "solid 2px #3f6c68" }}>
//                       Brings Extensive Professional Experience In Advising
//                       Multinational & Domestic Clients Across The Entire
//                       Spectrum Of Taxation Covering Advisory, Transaction
//                       Structuring, Compliance & Litigation.
//                     </FlipBack>
//                   </FlipBox>
//                 </HighlightItem>
//                 <HighlightItem>
//                   <FlipBox>
//                     <FlipFront>Excellent Teacher-Cum-Mentor</FlipFront>

//                     <FlipBack style={{ border: "solid 2px #3f6c68" }}>
//                       A Highly Regarded Mentor Who Has Guided Numerous
//                       Rank-Holders, With Students Securing All India Rank 1 &
//                       Marks As High As 97 Marks In Taxation.
//                     </FlipBack>
//                   </FlipBox>
//                 </HighlightItem>
//               </div>
//             </MentorCard>

//             <MentorImageWrap tw="order-2 md:order-1">
//               <DecorativeImage
//                 src={VectorDesign1}
//                 alt="decoration"
//                 className="float"
//                 style={{ top: "20px", right: "-20px" }}
//               />

//               <DecorativeImage
//                 src={VectorDesign2}
//                 alt="decoration"
//                 className="float"
//                 style={{ top: "40%", right: "-30px" }}
//               />

//               <DecorativeImage
//                 src={VectorDesign3}
//                 alt="decoration"
//                 className="float"
//                 style={{ bottom: "-20px", right: "20px" }}
//               />

//               <ImageStyled
//                 src="https://qsfiles.b-cdn.net/vg2.png"
//                 alt="Portrait of CA Vijender Aggarwal"
//                 style={{ zIndex: 1 }}
//               />
//             </MentorImageWrap>
//           </TwoCol>
//         </Section>
//       </MentorWrapper>
//     </PageWrapper>
//   );
// };

// export default AboutUs;

import React from "react";
import tw, { styled } from "twin.macro";
import VectorDesign from "images/Vector1.svg";
import VectorDesign1 from "images/hGreenDot.png";
import VectorDesign2 from "images/dottedCircle.svg";
import VectorDesign3 from "images/blueDots.svg";
import GrayDesign from "images/blueDots.svg";
import LineDesign from "images/greenLines.png";
import WhiteArrow from "images/Vector1.svg";

const HeroWrapper = styled.section`
  ${tw`flex flex-col items-center text-sm bg-cover bg-center bg-no-repeat`}
  background-image: url("https://raw.githubusercontent.com/prebuiltui/prebuiltui/main/assets/hero/bg-with-grid.png");
`;

const OfferBar = tw.div`
  w-full py-2 font-medium text-sm text-white text-center
  bg-gradient-to-r from-[#4F39F6] to-[#FDFEFF]
`;

const Navbar = tw.nav`
  z-50 flex items-center justify-between w-full
  py-4 px-6 md:px-16 lg:px-24 xl:px-32
  backdrop-blur text-gray-800 text-sm
`;

const NavLinks = tw.div`
  hidden md:flex items-center gap-8 transition duration-500
`;

const NavLink = tw.a`
  hover:text-gray-500 transition
`;

const NavButtons = tw.div`
  hidden md:block space-x-3
`;

const PrimaryBtn = tw.button`
  px-6 py-2 bg-indigo-600 hover:bg-indigo-700
  transition text-white rounded-md
`;

const SecondaryBtn = tw.button`
  hover:bg-gray-100 transition px-6 py-2
  border border-indigo-600 rounded-md
`;

const DecorativeImage = styled.img`
  ${tw`absolute z-0`}
  width: auto;
  height: auto;
  transition: transform 1s ease-in-out;

  &:hover {
    transform: scale(1.1) rotate(8deg);
  }

  &.top-left {
    top: 5%;
    left: 3%;
  }

  &.right-mid {
    top: 80%;
    right: 4%;
  }

  &.right-bottom {
    top: 100%;
    right: 2%;

    z-index: -1;
  }

  @media (max-width: 768px) {
    width: 80px;
    opacity: 0.25;
  }
`;

const BoxHeading = tw.h3`
   text-3xl md:text-5xl font-bold mb-8 text-[#1e293b] relative pb-4
 `;

const BoxHeadingUnderline = styled.span`
  ${tw`absolute left-0 bottom-0 w-24 h-1`}
  background-color: #14b8a6;
`;

const Section = tw.section`max-w-6xl mx-auto px-6 py-16`;

const TwoCol = tw.div`
  flex flex-col md:flex-row items-center gap-12
`;

const PhilosophyBox = tw.div`
  bg-white p-12 rounded-3xl shadow-xl relative
  w-full md:w-[65%] z-10
`;

const IllustrationContainer = styled.div`
  ${tw`relative flex justify-center items-center`}

  &:hover img.floating {
    animation-play-state: running;
  }

  img.floating {
    animation-play-state: paused;
  }
  //
`;

const MainImage = tw.img`
  w-full max-w-md mx-auto rounded-3xl object-cover
`;

const FloatingLayer = styled.img`
  ${tw`absolute pointer-events-none`}
  animation: float 3s ease-in-out infinite;

  @keyframes float {
    0% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(10px, -10px);
    }
    100% {
      transform: translate(0, 0);
    }
  }
`;

const ImageStyled = tw.img`
   w-full max-w-md mx-auto rounded-3xl  object-cover
 `;

const MentorWrapper = tw.section`
   bg-gradient-to-b from-[#f8fafc] to-white pt-40
 `;

const MentorHeading = tw.h1`
   text-center text-2xl lg:text-4xl font-bold mb-10 underline
 `;

const MentorCard = tw.div`

 `;

const MobileMenuBtn = tw.button`
  md:hidden active:scale-90 transition
`;

const MobileNav = styled.div(({ open }: { open: boolean }) => [
  tw`
    fixed inset-0 z-[100] bg-white backdrop-blur
    flex flex-col items-center justify-center
    text-lg gap-8 md:hidden
    transition-transform duration-300
  `,
  open ? tw`translate-x-0` : tw`-translate-x-full`,
]);

const Main = tw.main`
  flex flex-col items-center md:px-2 w-full
`;

const TrialBadge = tw.a`
  mt-16 flex items-center gap-2
  border border-indigo-200 rounded-full p-1 pr-3
  text-2xl font-medium text-indigo-500 bg-indigo-200
`;

const Badge = tw.span`
  bg-indigo-600 text-white text-2xl px-3 py-1 rounded-full
`;

const HeroTitle = tw.h1`
  text-center text-5xl leading-[68px] md:text-6xl md:leading-[80px]
  font-semibold max-w-4xl text-gray-900
`;

const HeroDesc = tw.p`
  text-justify text-xl lg:text-2xl lg:text-center leading-relaxed text-gray-700 px-4 lg:px-30  mb-0
`;

const CTAWrapper = tw.div`
  flex items-center gap-4 mt-8
`;

const DashboardImage = tw.img`
  w-full rounded-[15px] max-w-4xl mt-16
`;

const FeaturesWrapper = tw.section`
  py-20 px-4 bg-gradient-to-br from-[#fde7f3] via-[#e0f2fe] to-[#3c6f68]
 flex flex-col justify-center items-center gap-6
`;

const FeatureBadge = tw.button`
  px-4 h-2 border border-gray-800 bg-black text-gray-200 text-xs rounded-lg
`;

const SectionTitle = tw.h1`
  text-2xl md:text-5xl font-bold text-black py-0 my-0 text-center leading-tight
`;

const SectionDesc = tw.p`
  text-xl font-bold text-black max-w-xl text-center leading-9
`;

const Grid = tw.div`
  w-full max-w-6xl mx-auto
  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
  gap-6 mt-6
`;

const FeatureTitle = tw.p`
  font-medium text-2xl text-gray-100 py-0
`;

const FeatureDesc = tw.p`
  text-lg text-gray-200 leading-6 text-justify
`;

const FlipWrapper = styled.div`
  ${tw`relative w-[300px] h-[220px]`};
  perspective: 1000px;
`;

const FlipCard = styled.div`
  ${tw`absolute inset-0 w-full h-full`};
  transform-style: preserve-3d;
  transition: transform 0.6s ease;

  ${FlipWrapper}:hover & {
    transform: rotateX(180deg);
  }
`;

const FlipFace = styled.div`
  ${tw`
    absolute inset-0 w-[300px] h-[180px]
    rounded-lg bg-gradient-to-b from-[#020204] to-[#191130]
    border border-gray-700 p-6
    flex flex-col justify-center items-start
  `};
  backface-visibility: hidden;
`;

const FlipBack = styled(FlipFace)`
  transform: rotateX(180deg);
`;

const BulletItem = styled.li`
  ${tw`text-gray-700 text-xl pb-4`};
  display: grid;
  grid-template-columns: 24px 1fr;
  column-gap: 12px;
  align-items: start;
`;

const Tick = tw.span`text-[#14b8a6] text-2xl font-bold leading-none mt-2`;

const AboutUs = ({
  imageSrc1 = VectorDesign,
  imageSrc2 = GrayDesign,
  imageSrc3 = LineDesign,
}) => {
  const [open, setOpen] = React.useState(false);
  const featuresData = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: "white" }}
        >
          <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      ),
      title: "Top-Notch Graduation",
      description:
        "Alumnus Of Shri Ram College Of Commerce (SRCC), Delhi University, Widely Considered As India's Most Prestigious College For Commerce & Economics",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: "white", width: "48px", height: "48px" }}
        >
          <circle cx="12" cy="8" r="6" />
          <path d="M8.21 13.89 7 22l5-3 5 3-1.21-8.11" />
          <path d="m9.5 8.5 1.5 1 3-3" />
        </svg>
      ),
      title: "Academic Excellence Beyond Comparison	",
      description:
        "Secured 91% Marks At CA–Foundation Level & Achieved The Rare Distinction Of ‘ALL INDIA RANK 1' At Both CA–Intermediate & CA–Final Examinations .",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: "white" }}
        >
          <path d="M8 21h8" />
          <path d="M12 17v4" />
          <path d="M17 3H7v4a5 5 0 0 0 10 0V3z" />
          <path d="M7 3H5a2 2 0 0 0 0 4h2" />
          <path d="M17 3h2a2 2 0 1 1 0 4h-2" />
        </svg>
      ),
      title: "Best Paper Award Achievements	",
      description:
        "Recipient Of Multiple Best Paper Awards, Including Taxation (CA–Intermediate) and Advanced Management Accounting & Indirect Taxes (CA–Final).",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: "white" }}
        >
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
          <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
          <path d="M2 13h20" />
        </svg>
      ),
      title: "Big-4 Articleship",
      description:
        "Completed Articleship Training With Deloitte, A Globally Renowned Big-4 Professional Services Firm.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: "white" }}
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      title: "Seasoned  Professional",
      description:
        "Brings Extensive Professional Experience In Advising Multinational & Domestic Clients Across The Entire Spectrum Of Taxation Covering Advisory, Transaction Structuring, Compliance & Litigation.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: "white" }}
        >
          <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1" />
          <path d="m12 15 5 6H7Z" />
          <circle cx="12" cy="8" r="3" />
        </svg>
      ),
      title: "Excellent Teacher-Cum-Mentor",
      description:
        "A Highly Regarded Mentor Who Has Guided Numerous Rank-Holders, With Students Securing All India Rank 1 & Marks As High As 97 Marks In Taxation.",
    },
  ];

  return (
    <>
      <HeroWrapper>
        <Main>
          <TrialBadge href="#">
            <Badge>Home</Badge>
            About Us →
          </TrialBadge>

          <HeroTitle>About Us</HeroTitle>
          <HeroDesc>
            CA Vijender Aggarwal Classes is a dedicated platform for CA and CMA
            aspirants who seek strong conceptual clarity, practical
            understanding, and result-oriented preparation in Direct and
            Indirect Taxes. Our focus goes beyond merely completing the syllabus
            — we help students understand the taxation domain logically and
            apply it confidently in examinations as well as real-life scenarios.
            Along with academic excellence, we also provide proper practical
            exposure to ensure holistic learning.
          </HeroDesc>
        </Main>
      </HeroWrapper>

      <Section>
        <TwoCol>
          <IllustrationContainer>
            <MainImage
              src="https://qsfiles.b-cdn.net/vg1.png"
              style={{ zIndex: 10 }}
            />

            {/* BEFORE image */}
            <FloatingLayer
              className="floating"
              src={VectorDesign2}
              style={{ top: "-30px", left: "-30px" }}
            />

            {/* AFTER image */}
            <FloatingLayer
              className="floating"
              src={imageSrc2}
              style={{ bottom: "-20px", right: "-20px" }}
            />
          </IllustrationContainer>

          <PhilosophyBox style={{ zIndex: 1 }}>
            <DecorativeImage
              src={VectorDesign2}
              alt="decoration"
              style={{ bottom: "-40px", right: "-30px" }}
            />

            <BoxHeading>
              TEACHING PHILOSOPHY
              <BoxHeadingUnderline />
            </BoxHeading>

            <p
              tw="mb-8 text-gray-700 text-2xl leading-relaxed"
              style={{
                textAlign: "justify",
                lineHeight: "1.60",
                fontSize: "20px",
              }}
            >
              At CA Vijender Aggarwal Classes, teaching goes beyond books. Every
              topic is explained in a simplified, exam-oriented, and practical
              manner, keeping in mind the challenges faced by CA/CMA students
              today.
            </p>

            <ul
              tw="space-y-4 list-none pl-0"
              style={{
                paddingLeft: "10px",
                lineHeight: "1.6",
                fontSize: "18px",
              }}
            >
              <BulletItem>
                <Tick>✓</Tick>
                <span>
                  Focus on conceptual clarity & practical application of the
                  subject to simplify the process of interpretation & learning
                  of law.
                </span>
              </BulletItem>

              <BulletItem>
                <Tick>✓</Tick>
                <span>
                  Use of real-world and practical examples for better
                  understanding.
                </span>
              </BulletItem>

              <BulletItem>
                <Tick>✓</Tick>
                <span>
                  Exam-focused preparation aligned with current CA/CMA patterns.
                </span>
              </BulletItem>

              <BulletItem>
                <Tick>✓</Tick>
                <span>
                  Regular revision and structured practice to reinforce
                  learning.
                </span>
              </BulletItem>

              <BulletItem>
                <Tick>✓</Tick>
                <span>
                  Practical exposure to bridge the gap between theory and
                  real-life application.
                </span>
              </BulletItem>
            </ul>

            <p
              tw="mb-8 text-gray-700 text-lg leading-relaxed"
              style={{
                textAlign: "justify",
                lineHeight: "1.60",
                fontSize: "18px",
              }}
            >
              At CA Vijender Aggarwal Classes, we aim to create confident
              professionals who are well-prepared not only for examinations but
              also for real-world professional responsibilities.
            </p>
          </PhilosophyBox>
        </TwoCol>
      </Section>

      <FeaturesWrapper>
        <FeatureBadge></FeatureBadge>

        <SectionTitle style={{ textTransform: "uppercase" }}>
          About CA Vijender Aggarwal
        </SectionTitle>

        <SectionDesc>
          Empowering CA & CMA Aspirants with Conceptual Mastery and Practical
          Insight
        </SectionDesc>

        <Grid>
          {featuresData.map((feature: any, index: number) => (
            <FlipWrapper key={index} className="group">
              <FlipCard>
                {/* FRONT — Title only */}
                <FlipFace>
                  {feature.icon}
                  <FeatureTitle>{feature.title}</FeatureTitle>
                </FlipFace>

                {/* BACK — Description */}
                <FlipBack>
                  <FeatureDesc>{feature.description}</FeatureDesc>
                </FlipBack>
              </FlipCard>
            </FlipWrapper>
          ))}
        </Grid>
      </FeaturesWrapper>
    </>
  );
};

export default AboutUs;
